export default __webpack_public_path__ + "static/media/PENSION.02626de4.svg";